import { ABSOLUTE_PATHS } from "@/core/constants";

// Routes that share a key keep the same page component mounted across navigation.
export default function getRouteKey(asPath: string): string {
  const inducteeClassLandingPattern = /^\/(?:[a-z]{2}\/)?inductees(?:\/classes\/?)?\/?$/;
  if (asPath.match(inducteeClassLandingPattern)) {
    return ABSOLUTE_PATHS.INDUCTEE_LANDING;
  } else if (asPath.includes("rrtv")) {
    return ABSOLUTE_PATHS.RRTV;
  }
  return asPath.split(/[?#]/)[0];
}
